/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const MarketQuote = $root.MarketQuote = (() => {

    /**
     * Properties of a MarketQuote.
     * @exports IMarketQuote
     * @interface IMarketQuote
     * @property {string|null} [stockCd] MarketQuote stockCd
     * @property {string|null} [buy] MarketQuote buy
     * @property {string|null} [sell] MarketQuote sell
     * @property {string|null} [buySize] MarketQuote buySize
     * @property {string|null} [sellSize] MarketQuote sellSize
     * @property {number|Long|null} [timestamp] MarketQuote timestamp
     */

    /**
     * Constructs a new MarketQuote.
     * @exports MarketQuote
     * @classdesc Represents a MarketQuote.
     * @implements IMarketQuote
     * @constructor
     * @param {IMarketQuote=} [properties] Properties to set
     */
    function MarketQuote(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketQuote stockCd.
     * @member {string} stockCd
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.stockCd = "";

    /**
     * MarketQuote buy.
     * @member {string} buy
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.buy = "";

    /**
     * MarketQuote sell.
     * @member {string} sell
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.sell = "";

    /**
     * MarketQuote buySize.
     * @member {string} buySize
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.buySize = "";

    /**
     * MarketQuote sellSize.
     * @member {string} sellSize
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.sellSize = "";

    /**
     * MarketQuote timestamp.
     * @member {number|Long} timestamp
     * @memberof MarketQuote
     * @instance
     */
    MarketQuote.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new MarketQuote instance using the specified properties.
     * @function create
     * @memberof MarketQuote
     * @static
     * @param {IMarketQuote=} [properties] Properties to set
     * @returns {MarketQuote} MarketQuote instance
     */
    MarketQuote.create = function create(properties) {
        return new MarketQuote(properties);
    };

    /**
     * Encodes the specified MarketQuote message. Does not implicitly {@link MarketQuote.verify|verify} messages.
     * @function encode
     * @memberof MarketQuote
     * @static
     * @param {IMarketQuote} message MarketQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketQuote.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.stockCd);
        if (message.buy != null && Object.hasOwnProperty.call(message, "buy"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.buy);
        if (message.sell != null && Object.hasOwnProperty.call(message, "sell"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sell);
        if (message.buySize != null && Object.hasOwnProperty.call(message, "buySize"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.buySize);
        if (message.sellSize != null && Object.hasOwnProperty.call(message, "sellSize"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sellSize);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.timestamp);
        return writer;
    };

    /**
     * Encodes the specified MarketQuote message, length delimited. Does not implicitly {@link MarketQuote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketQuote
     * @static
     * @param {IMarketQuote} message MarketQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketQuote.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketQuote message from the specified reader or buffer.
     * @function decode
     * @memberof MarketQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketQuote} MarketQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketQuote.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketQuote();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.stockCd = reader.string();
                    break;
                }
            case 2: {
                    message.buy = reader.string();
                    break;
                }
            case 3: {
                    message.sell = reader.string();
                    break;
                }
            case 4: {
                    message.buySize = reader.string();
                    break;
                }
            case 5: {
                    message.sellSize = reader.string();
                    break;
                }
            case 6: {
                    message.timestamp = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketQuote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketQuote} MarketQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketQuote.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketQuote message.
     * @function verify
     * @memberof MarketQuote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketQuote.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.buy != null && message.hasOwnProperty("buy"))
            if (!$util.isString(message.buy))
                return "buy: string expected";
        if (message.sell != null && message.hasOwnProperty("sell"))
            if (!$util.isString(message.sell))
                return "sell: string expected";
        if (message.buySize != null && message.hasOwnProperty("buySize"))
            if (!$util.isString(message.buySize))
                return "buySize: string expected";
        if (message.sellSize != null && message.hasOwnProperty("sellSize"))
            if (!$util.isString(message.sellSize))
                return "sellSize: string expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates a MarketQuote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketQuote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketQuote} MarketQuote
     */
    MarketQuote.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketQuote)
            return object;
        let message = new $root.MarketQuote();
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.buy != null)
            message.buy = String(object.buy);
        if (object.sell != null)
            message.sell = String(object.sell);
        if (object.buySize != null)
            message.buySize = String(object.buySize);
        if (object.sellSize != null)
            message.sellSize = String(object.sellSize);
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a MarketQuote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketQuote
     * @static
     * @param {MarketQuote} message MarketQuote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketQuote.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.stockCd = "";
            object.buy = "";
            object.sell = "";
            object.buySize = "";
            object.sellSize = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
        }
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.buy != null && message.hasOwnProperty("buy"))
            object.buy = message.buy;
        if (message.sell != null && message.hasOwnProperty("sell"))
            object.sell = message.sell;
        if (message.buySize != null && message.hasOwnProperty("buySize"))
            object.buySize = message.buySize;
        if (message.sellSize != null && message.hasOwnProperty("sellSize"))
            object.sellSize = message.sellSize;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        return object;
    };

    /**
     * Converts this MarketQuote to JSON.
     * @function toJSON
     * @memberof MarketQuote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketQuote.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarketQuote
     * @function getTypeUrl
     * @memberof MarketQuote
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarketQuote.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarketQuote";
    };

    return MarketQuote;
})();

export const MarketQuoteList = $root.MarketQuoteList = (() => {

    /**
     * Properties of a MarketQuoteList.
     * @exports IMarketQuoteList
     * @interface IMarketQuoteList
     * @property {Array.<IMarketQuote>|null} [quotes] MarketQuoteList quotes
     */

    /**
     * Constructs a new MarketQuoteList.
     * @exports MarketQuoteList
     * @classdesc Represents a MarketQuoteList.
     * @implements IMarketQuoteList
     * @constructor
     * @param {IMarketQuoteList=} [properties] Properties to set
     */
    function MarketQuoteList(properties) {
        this.quotes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketQuoteList quotes.
     * @member {Array.<IMarketQuote>} quotes
     * @memberof MarketQuoteList
     * @instance
     */
    MarketQuoteList.prototype.quotes = $util.emptyArray;

    /**
     * Creates a new MarketQuoteList instance using the specified properties.
     * @function create
     * @memberof MarketQuoteList
     * @static
     * @param {IMarketQuoteList=} [properties] Properties to set
     * @returns {MarketQuoteList} MarketQuoteList instance
     */
    MarketQuoteList.create = function create(properties) {
        return new MarketQuoteList(properties);
    };

    /**
     * Encodes the specified MarketQuoteList message. Does not implicitly {@link MarketQuoteList.verify|verify} messages.
     * @function encode
     * @memberof MarketQuoteList
     * @static
     * @param {IMarketQuoteList} message MarketQuoteList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketQuoteList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.quotes != null && message.quotes.length)
            for (let i = 0; i < message.quotes.length; ++i)
                $root.MarketQuote.encode(message.quotes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MarketQuoteList message, length delimited. Does not implicitly {@link MarketQuoteList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketQuoteList
     * @static
     * @param {IMarketQuoteList} message MarketQuoteList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketQuoteList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketQuoteList message from the specified reader or buffer.
     * @function decode
     * @memberof MarketQuoteList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketQuoteList} MarketQuoteList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketQuoteList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketQuoteList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.quotes && message.quotes.length))
                        message.quotes = [];
                    message.quotes.push($root.MarketQuote.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketQuoteList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketQuoteList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketQuoteList} MarketQuoteList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketQuoteList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketQuoteList message.
     * @function verify
     * @memberof MarketQuoteList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketQuoteList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.quotes != null && message.hasOwnProperty("quotes")) {
            if (!Array.isArray(message.quotes))
                return "quotes: array expected";
            for (let i = 0; i < message.quotes.length; ++i) {
                let error = $root.MarketQuote.verify(message.quotes[i]);
                if (error)
                    return "quotes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MarketQuoteList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketQuoteList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketQuoteList} MarketQuoteList
     */
    MarketQuoteList.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketQuoteList)
            return object;
        let message = new $root.MarketQuoteList();
        if (object.quotes) {
            if (!Array.isArray(object.quotes))
                throw TypeError(".MarketQuoteList.quotes: array expected");
            message.quotes = [];
            for (let i = 0; i < object.quotes.length; ++i) {
                if (typeof object.quotes[i] !== "object")
                    throw TypeError(".MarketQuoteList.quotes: object expected");
                message.quotes[i] = $root.MarketQuote.fromObject(object.quotes[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MarketQuoteList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketQuoteList
     * @static
     * @param {MarketQuoteList} message MarketQuoteList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketQuoteList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.quotes = [];
        if (message.quotes && message.quotes.length) {
            object.quotes = [];
            for (let j = 0; j < message.quotes.length; ++j)
                object.quotes[j] = $root.MarketQuote.toObject(message.quotes[j], options);
        }
        return object;
    };

    /**
     * Converts this MarketQuoteList to JSON.
     * @function toJSON
     * @memberof MarketQuoteList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketQuoteList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarketQuoteList
     * @function getTypeUrl
     * @memberof MarketQuoteList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarketQuoteList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarketQuoteList";
    };

    return MarketQuoteList;
})();

export const Quote = $root.Quote = (() => {

    /**
     * Properties of a Quote.
     * @exports IQuote
     * @interface IQuote
     * @property {string|null} [buy] Quote buy
     * @property {string|null} [sell] Quote sell
     * @property {string|null} [buySize] Quote buySize
     * @property {string|null} [sellSize] Quote sellSize
     */

    /**
     * Constructs a new Quote.
     * @exports Quote
     * @classdesc Represents a Quote.
     * @implements IQuote
     * @constructor
     * @param {IQuote=} [properties] Properties to set
     */
    function Quote(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Quote buy.
     * @member {string} buy
     * @memberof Quote
     * @instance
     */
    Quote.prototype.buy = "";

    /**
     * Quote sell.
     * @member {string} sell
     * @memberof Quote
     * @instance
     */
    Quote.prototype.sell = "";

    /**
     * Quote buySize.
     * @member {string} buySize
     * @memberof Quote
     * @instance
     */
    Quote.prototype.buySize = "";

    /**
     * Quote sellSize.
     * @member {string} sellSize
     * @memberof Quote
     * @instance
     */
    Quote.prototype.sellSize = "";

    /**
     * Creates a new Quote instance using the specified properties.
     * @function create
     * @memberof Quote
     * @static
     * @param {IQuote=} [properties] Properties to set
     * @returns {Quote} Quote instance
     */
    Quote.create = function create(properties) {
        return new Quote(properties);
    };

    /**
     * Encodes the specified Quote message. Does not implicitly {@link Quote.verify|verify} messages.
     * @function encode
     * @memberof Quote
     * @static
     * @param {IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.buy != null && Object.hasOwnProperty.call(message, "buy"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.buy);
        if (message.sell != null && Object.hasOwnProperty.call(message, "sell"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sell);
        if (message.buySize != null && Object.hasOwnProperty.call(message, "buySize"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.buySize);
        if (message.sellSize != null && Object.hasOwnProperty.call(message, "sellSize"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.sellSize);
        return writer;
    };

    /**
     * Encodes the specified Quote message, length delimited. Does not implicitly {@link Quote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Quote
     * @static
     * @param {IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Quote message from the specified reader or buffer.
     * @function decode
     * @memberof Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Quote();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.buy = reader.string();
                    break;
                }
            case 2: {
                    message.sell = reader.string();
                    break;
                }
            case 3: {
                    message.buySize = reader.string();
                    break;
                }
            case 4: {
                    message.sellSize = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Quote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Quote message.
     * @function verify
     * @memberof Quote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Quote.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.buy != null && message.hasOwnProperty("buy"))
            if (!$util.isString(message.buy))
                return "buy: string expected";
        if (message.sell != null && message.hasOwnProperty("sell"))
            if (!$util.isString(message.sell))
                return "sell: string expected";
        if (message.buySize != null && message.hasOwnProperty("buySize"))
            if (!$util.isString(message.buySize))
                return "buySize: string expected";
        if (message.sellSize != null && message.hasOwnProperty("sellSize"))
            if (!$util.isString(message.sellSize))
                return "sellSize: string expected";
        return null;
    };

    /**
     * Creates a Quote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Quote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Quote} Quote
     */
    Quote.fromObject = function fromObject(object) {
        if (object instanceof $root.Quote)
            return object;
        let message = new $root.Quote();
        if (object.buy != null)
            message.buy = String(object.buy);
        if (object.sell != null)
            message.sell = String(object.sell);
        if (object.buySize != null)
            message.buySize = String(object.buySize);
        if (object.sellSize != null)
            message.sellSize = String(object.sellSize);
        return message;
    };

    /**
     * Creates a plain object from a Quote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Quote
     * @static
     * @param {Quote} message Quote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Quote.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.buy = "";
            object.sell = "";
            object.buySize = "";
            object.sellSize = "";
        }
        if (message.buy != null && message.hasOwnProperty("buy"))
            object.buy = message.buy;
        if (message.sell != null && message.hasOwnProperty("sell"))
            object.sell = message.sell;
        if (message.buySize != null && message.hasOwnProperty("buySize"))
            object.buySize = message.buySize;
        if (message.sellSize != null && message.hasOwnProperty("sellSize"))
            object.sellSize = message.sellSize;
        return object;
    };

    /**
     * Converts this Quote to JSON.
     * @function toJSON
     * @memberof Quote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Quote.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Quote
     * @function getTypeUrl
     * @memberof Quote
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Quote.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Quote";
    };

    return Quote;
})();

export const MarketOrderBook = $root.MarketOrderBook = (() => {

    /**
     * Properties of a MarketOrderBook.
     * @exports IMarketOrderBook
     * @interface IMarketOrderBook
     * @property {string|null} [stockCd] MarketOrderBook stockCd
     * @property {Array.<IQuote>|null} [quotes] MarketOrderBook quotes
     * @property {number|Long|null} [timestamp] MarketOrderBook timestamp
     */

    /**
     * Constructs a new MarketOrderBook.
     * @exports MarketOrderBook
     * @classdesc Represents a MarketOrderBook.
     * @implements IMarketOrderBook
     * @constructor
     * @param {IMarketOrderBook=} [properties] Properties to set
     */
    function MarketOrderBook(properties) {
        this.quotes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketOrderBook stockCd.
     * @member {string} stockCd
     * @memberof MarketOrderBook
     * @instance
     */
    MarketOrderBook.prototype.stockCd = "";

    /**
     * MarketOrderBook quotes.
     * @member {Array.<IQuote>} quotes
     * @memberof MarketOrderBook
     * @instance
     */
    MarketOrderBook.prototype.quotes = $util.emptyArray;

    /**
     * MarketOrderBook timestamp.
     * @member {number|Long} timestamp
     * @memberof MarketOrderBook
     * @instance
     */
    MarketOrderBook.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new MarketOrderBook instance using the specified properties.
     * @function create
     * @memberof MarketOrderBook
     * @static
     * @param {IMarketOrderBook=} [properties] Properties to set
     * @returns {MarketOrderBook} MarketOrderBook instance
     */
    MarketOrderBook.create = function create(properties) {
        return new MarketOrderBook(properties);
    };

    /**
     * Encodes the specified MarketOrderBook message. Does not implicitly {@link MarketOrderBook.verify|verify} messages.
     * @function encode
     * @memberof MarketOrderBook
     * @static
     * @param {IMarketOrderBook} message MarketOrderBook message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketOrderBook.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.stockCd);
        if (message.quotes != null && message.quotes.length)
            for (let i = 0; i < message.quotes.length; ++i)
                $root.Quote.encode(message.quotes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.timestamp);
        return writer;
    };

    /**
     * Encodes the specified MarketOrderBook message, length delimited. Does not implicitly {@link MarketOrderBook.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketOrderBook
     * @static
     * @param {IMarketOrderBook} message MarketOrderBook message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketOrderBook.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketOrderBook message from the specified reader or buffer.
     * @function decode
     * @memberof MarketOrderBook
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketOrderBook} MarketOrderBook
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketOrderBook.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketOrderBook();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.stockCd = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.quotes && message.quotes.length))
                        message.quotes = [];
                    message.quotes.push($root.Quote.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.timestamp = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketOrderBook message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketOrderBook
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketOrderBook} MarketOrderBook
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketOrderBook.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketOrderBook message.
     * @function verify
     * @memberof MarketOrderBook
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketOrderBook.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.quotes != null && message.hasOwnProperty("quotes")) {
            if (!Array.isArray(message.quotes))
                return "quotes: array expected";
            for (let i = 0; i < message.quotes.length; ++i) {
                let error = $root.Quote.verify(message.quotes[i]);
                if (error)
                    return "quotes." + error;
            }
        }
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates a MarketOrderBook message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketOrderBook
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketOrderBook} MarketOrderBook
     */
    MarketOrderBook.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketOrderBook)
            return object;
        let message = new $root.MarketOrderBook();
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.quotes) {
            if (!Array.isArray(object.quotes))
                throw TypeError(".MarketOrderBook.quotes: array expected");
            message.quotes = [];
            for (let i = 0; i < object.quotes.length; ++i) {
                if (typeof object.quotes[i] !== "object")
                    throw TypeError(".MarketOrderBook.quotes: object expected");
                message.quotes[i] = $root.Quote.fromObject(object.quotes[i]);
            }
        }
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a MarketOrderBook message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketOrderBook
     * @static
     * @param {MarketOrderBook} message MarketOrderBook
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketOrderBook.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.quotes = [];
        if (options.defaults) {
            object.stockCd = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
        }
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.quotes && message.quotes.length) {
            object.quotes = [];
            for (let j = 0; j < message.quotes.length; ++j)
                object.quotes[j] = $root.Quote.toObject(message.quotes[j], options);
        }
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        return object;
    };

    /**
     * Converts this MarketOrderBook to JSON.
     * @function toJSON
     * @memberof MarketOrderBook
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketOrderBook.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarketOrderBook
     * @function getTypeUrl
     * @memberof MarketOrderBook
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarketOrderBook.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarketOrderBook";
    };

    return MarketOrderBook;
})();

export const OrderBookCancel = $root.OrderBookCancel = (() => {

    /**
     * Properties of an OrderBookCancel.
     * @exports IOrderBookCancel
     * @interface IOrderBookCancel
     * @property {string|null} [cancelType] OrderBookCancel cancelType
     * @property {string|null} [stockCd] OrderBookCancel stockCd
     * @property {number|Long|null} [timestamp] OrderBookCancel timestamp
     */

    /**
     * Constructs a new OrderBookCancel.
     * @exports OrderBookCancel
     * @classdesc Represents an OrderBookCancel.
     * @implements IOrderBookCancel
     * @constructor
     * @param {IOrderBookCancel=} [properties] Properties to set
     */
    function OrderBookCancel(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderBookCancel cancelType.
     * @member {string} cancelType
     * @memberof OrderBookCancel
     * @instance
     */
    OrderBookCancel.prototype.cancelType = "";

    /**
     * OrderBookCancel stockCd.
     * @member {string} stockCd
     * @memberof OrderBookCancel
     * @instance
     */
    OrderBookCancel.prototype.stockCd = "";

    /**
     * OrderBookCancel timestamp.
     * @member {number|Long} timestamp
     * @memberof OrderBookCancel
     * @instance
     */
    OrderBookCancel.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new OrderBookCancel instance using the specified properties.
     * @function create
     * @memberof OrderBookCancel
     * @static
     * @param {IOrderBookCancel=} [properties] Properties to set
     * @returns {OrderBookCancel} OrderBookCancel instance
     */
    OrderBookCancel.create = function create(properties) {
        return new OrderBookCancel(properties);
    };

    /**
     * Encodes the specified OrderBookCancel message. Does not implicitly {@link OrderBookCancel.verify|verify} messages.
     * @function encode
     * @memberof OrderBookCancel
     * @static
     * @param {IOrderBookCancel} message OrderBookCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderBookCancel.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.cancelType != null && Object.hasOwnProperty.call(message, "cancelType"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cancelType);
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.stockCd);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.timestamp);
        return writer;
    };

    /**
     * Encodes the specified OrderBookCancel message, length delimited. Does not implicitly {@link OrderBookCancel.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderBookCancel
     * @static
     * @param {IOrderBookCancel} message OrderBookCancel message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderBookCancel.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderBookCancel message from the specified reader or buffer.
     * @function decode
     * @memberof OrderBookCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderBookCancel} OrderBookCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderBookCancel.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderBookCancel();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.cancelType = reader.string();
                    break;
                }
            case 2: {
                    message.stockCd = reader.string();
                    break;
                }
            case 3: {
                    message.timestamp = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderBookCancel message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderBookCancel
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderBookCancel} OrderBookCancel
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderBookCancel.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderBookCancel message.
     * @function verify
     * @memberof OrderBookCancel
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderBookCancel.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.cancelType != null && message.hasOwnProperty("cancelType"))
            if (!$util.isString(message.cancelType))
                return "cancelType: string expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates an OrderBookCancel message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderBookCancel
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderBookCancel} OrderBookCancel
     */
    OrderBookCancel.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderBookCancel)
            return object;
        let message = new $root.OrderBookCancel();
        if (object.cancelType != null)
            message.cancelType = String(object.cancelType);
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = true;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from an OrderBookCancel message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderBookCancel
     * @static
     * @param {OrderBookCancel} message OrderBookCancel
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderBookCancel.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.cancelType = "";
            object.stockCd = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
        }
        if (message.cancelType != null && message.hasOwnProperty("cancelType"))
            object.cancelType = message.cancelType;
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber(true) : message.timestamp;
        return object;
    };

    /**
     * Converts this OrderBookCancel to JSON.
     * @function toJSON
     * @memberof OrderBookCancel
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderBookCancel.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderBookCancel
     * @function getTypeUrl
     * @memberof OrderBookCancel
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderBookCancel.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderBookCancel";
    };

    return OrderBookCancel;
})();

export const MarketTicker = $root.MarketTicker = (() => {

    /**
     * Properties of a MarketTicker.
     * @exports IMarketTicker
     * @interface IMarketTicker
     * @property {string|null} [stockCd] MarketTicker stockCd
     * @property {string|null} [date] MarketTicker date
     * @property {string|null} [open] MarketTicker open
     * @property {string|null} [high] MarketTicker high
     * @property {string|null} [low] MarketTicker low
     * @property {string|null} [close] MarketTicker close
     * @property {string|null} [beforeClose] MarketTicker beforeClose
     * @property {string|null} [lastUpdated] MarketTicker lastUpdated
     */

    /**
     * Constructs a new MarketTicker.
     * @exports MarketTicker
     * @classdesc Represents a MarketTicker.
     * @implements IMarketTicker
     * @constructor
     * @param {IMarketTicker=} [properties] Properties to set
     */
    function MarketTicker(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketTicker stockCd.
     * @member {string} stockCd
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.stockCd = "";

    /**
     * MarketTicker date.
     * @member {string} date
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.date = "";

    /**
     * MarketTicker open.
     * @member {string} open
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.open = "";

    /**
     * MarketTicker high.
     * @member {string} high
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.high = "";

    /**
     * MarketTicker low.
     * @member {string} low
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.low = "";

    /**
     * MarketTicker close.
     * @member {string} close
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.close = "";

    /**
     * MarketTicker beforeClose.
     * @member {string} beforeClose
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.beforeClose = "";

    /**
     * MarketTicker lastUpdated.
     * @member {string} lastUpdated
     * @memberof MarketTicker
     * @instance
     */
    MarketTicker.prototype.lastUpdated = "";

    /**
     * Creates a new MarketTicker instance using the specified properties.
     * @function create
     * @memberof MarketTicker
     * @static
     * @param {IMarketTicker=} [properties] Properties to set
     * @returns {MarketTicker} MarketTicker instance
     */
    MarketTicker.create = function create(properties) {
        return new MarketTicker(properties);
    };

    /**
     * Encodes the specified MarketTicker message. Does not implicitly {@link MarketTicker.verify|verify} messages.
     * @function encode
     * @memberof MarketTicker
     * @static
     * @param {IMarketTicker} message MarketTicker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketTicker.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.stockCd);
        if (message.date != null && Object.hasOwnProperty.call(message, "date"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.date);
        if (message.open != null && Object.hasOwnProperty.call(message, "open"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.open);
        if (message.high != null && Object.hasOwnProperty.call(message, "high"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.high);
        if (message.low != null && Object.hasOwnProperty.call(message, "low"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.low);
        if (message.close != null && Object.hasOwnProperty.call(message, "close"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.close);
        if (message.beforeClose != null && Object.hasOwnProperty.call(message, "beforeClose"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.beforeClose);
        if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.lastUpdated);
        return writer;
    };

    /**
     * Encodes the specified MarketTicker message, length delimited. Does not implicitly {@link MarketTicker.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketTicker
     * @static
     * @param {IMarketTicker} message MarketTicker message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketTicker.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketTicker message from the specified reader or buffer.
     * @function decode
     * @memberof MarketTicker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketTicker} MarketTicker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketTicker.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketTicker();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.stockCd = reader.string();
                    break;
                }
            case 2: {
                    message.date = reader.string();
                    break;
                }
            case 3: {
                    message.open = reader.string();
                    break;
                }
            case 4: {
                    message.high = reader.string();
                    break;
                }
            case 5: {
                    message.low = reader.string();
                    break;
                }
            case 6: {
                    message.close = reader.string();
                    break;
                }
            case 7: {
                    message.beforeClose = reader.string();
                    break;
                }
            case 8: {
                    message.lastUpdated = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketTicker message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketTicker
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketTicker} MarketTicker
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketTicker.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketTicker message.
     * @function verify
     * @memberof MarketTicker
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketTicker.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.date != null && message.hasOwnProperty("date"))
            if (!$util.isString(message.date))
                return "date: string expected";
        if (message.open != null && message.hasOwnProperty("open"))
            if (!$util.isString(message.open))
                return "open: string expected";
        if (message.high != null && message.hasOwnProperty("high"))
            if (!$util.isString(message.high))
                return "high: string expected";
        if (message.low != null && message.hasOwnProperty("low"))
            if (!$util.isString(message.low))
                return "low: string expected";
        if (message.close != null && message.hasOwnProperty("close"))
            if (!$util.isString(message.close))
                return "close: string expected";
        if (message.beforeClose != null && message.hasOwnProperty("beforeClose"))
            if (!$util.isString(message.beforeClose))
                return "beforeClose: string expected";
        if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
            if (!$util.isString(message.lastUpdated))
                return "lastUpdated: string expected";
        return null;
    };

    /**
     * Creates a MarketTicker message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketTicker
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketTicker} MarketTicker
     */
    MarketTicker.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketTicker)
            return object;
        let message = new $root.MarketTicker();
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.date != null)
            message.date = String(object.date);
        if (object.open != null)
            message.open = String(object.open);
        if (object.high != null)
            message.high = String(object.high);
        if (object.low != null)
            message.low = String(object.low);
        if (object.close != null)
            message.close = String(object.close);
        if (object.beforeClose != null)
            message.beforeClose = String(object.beforeClose);
        if (object.lastUpdated != null)
            message.lastUpdated = String(object.lastUpdated);
        return message;
    };

    /**
     * Creates a plain object from a MarketTicker message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketTicker
     * @static
     * @param {MarketTicker} message MarketTicker
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketTicker.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.stockCd = "";
            object.date = "";
            object.open = "";
            object.high = "";
            object.low = "";
            object.close = "";
            object.beforeClose = "";
            object.lastUpdated = "";
        }
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.date != null && message.hasOwnProperty("date"))
            object.date = message.date;
        if (message.open != null && message.hasOwnProperty("open"))
            object.open = message.open;
        if (message.high != null && message.hasOwnProperty("high"))
            object.high = message.high;
        if (message.low != null && message.hasOwnProperty("low"))
            object.low = message.low;
        if (message.close != null && message.hasOwnProperty("close"))
            object.close = message.close;
        if (message.beforeClose != null && message.hasOwnProperty("beforeClose"))
            object.beforeClose = message.beforeClose;
        if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
            object.lastUpdated = message.lastUpdated;
        return object;
    };

    /**
     * Converts this MarketTicker to JSON.
     * @function toJSON
     * @memberof MarketTicker
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketTicker.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarketTicker
     * @function getTypeUrl
     * @memberof MarketTicker
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarketTicker.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarketTicker";
    };

    return MarketTicker;
})();

export const MarketTickerList = $root.MarketTickerList = (() => {

    /**
     * Properties of a MarketTickerList.
     * @exports IMarketTickerList
     * @interface IMarketTickerList
     * @property {Array.<IMarketTicker>|null} [tickers] MarketTickerList tickers
     */

    /**
     * Constructs a new MarketTickerList.
     * @exports MarketTickerList
     * @classdesc Represents a MarketTickerList.
     * @implements IMarketTickerList
     * @constructor
     * @param {IMarketTickerList=} [properties] Properties to set
     */
    function MarketTickerList(properties) {
        this.tickers = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketTickerList tickers.
     * @member {Array.<IMarketTicker>} tickers
     * @memberof MarketTickerList
     * @instance
     */
    MarketTickerList.prototype.tickers = $util.emptyArray;

    /**
     * Creates a new MarketTickerList instance using the specified properties.
     * @function create
     * @memberof MarketTickerList
     * @static
     * @param {IMarketTickerList=} [properties] Properties to set
     * @returns {MarketTickerList} MarketTickerList instance
     */
    MarketTickerList.create = function create(properties) {
        return new MarketTickerList(properties);
    };

    /**
     * Encodes the specified MarketTickerList message. Does not implicitly {@link MarketTickerList.verify|verify} messages.
     * @function encode
     * @memberof MarketTickerList
     * @static
     * @param {IMarketTickerList} message MarketTickerList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketTickerList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.tickers != null && message.tickers.length)
            for (let i = 0; i < message.tickers.length; ++i)
                $root.MarketTicker.encode(message.tickers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MarketTickerList message, length delimited. Does not implicitly {@link MarketTickerList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketTickerList
     * @static
     * @param {IMarketTickerList} message MarketTickerList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketTickerList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketTickerList message from the specified reader or buffer.
     * @function decode
     * @memberof MarketTickerList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketTickerList} MarketTickerList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketTickerList.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketTickerList();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.tickers && message.tickers.length))
                        message.tickers = [];
                    message.tickers.push($root.MarketTicker.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketTickerList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketTickerList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketTickerList} MarketTickerList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketTickerList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketTickerList message.
     * @function verify
     * @memberof MarketTickerList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketTickerList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.tickers != null && message.hasOwnProperty("tickers")) {
            if (!Array.isArray(message.tickers))
                return "tickers: array expected";
            for (let i = 0; i < message.tickers.length; ++i) {
                let error = $root.MarketTicker.verify(message.tickers[i]);
                if (error)
                    return "tickers." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MarketTickerList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketTickerList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketTickerList} MarketTickerList
     */
    MarketTickerList.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketTickerList)
            return object;
        let message = new $root.MarketTickerList();
        if (object.tickers) {
            if (!Array.isArray(object.tickers))
                throw TypeError(".MarketTickerList.tickers: array expected");
            message.tickers = [];
            for (let i = 0; i < object.tickers.length; ++i) {
                if (typeof object.tickers[i] !== "object")
                    throw TypeError(".MarketTickerList.tickers: object expected");
                message.tickers[i] = $root.MarketTicker.fromObject(object.tickers[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MarketTickerList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketTickerList
     * @static
     * @param {MarketTickerList} message MarketTickerList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketTickerList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.tickers = [];
        if (message.tickers && message.tickers.length) {
            object.tickers = [];
            for (let j = 0; j < message.tickers.length; ++j)
                object.tickers[j] = $root.MarketTicker.toObject(message.tickers[j], options);
        }
        return object;
    };

    /**
     * Converts this MarketTickerList to JSON.
     * @function toJSON
     * @memberof MarketTickerList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketTickerList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarketTickerList
     * @function getTypeUrl
     * @memberof MarketTickerList
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarketTickerList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarketTickerList";
    };

    return MarketTickerList;
})();

export const OrderReceived = $root.OrderReceived = (() => {

    /**
     * Properties of an OrderReceived.
     * @exports IOrderReceived
     * @interface IOrderReceived
     * @property {string|null} [accountNo] OrderReceived accountNo
     * @property {string|null} [orderDateTime] OrderReceived orderDateTime
     * @property {string|null} [orderNo] OrderReceived orderNo
     * @property {string|null} [stockCd] OrderReceived stockCd
     * @property {string|null} [orderVersionCd] OrderReceived orderVersionCd
     * @property {string|null} [positionCd] OrderReceived positionCd
     * @property {string|null} [orderTypeCd] OrderReceived orderTypeCd
     * @property {string|null} [sideCd] OrderReceived sideCd
     * @property {string|null} [orderQuantity] OrderReceived orderQuantity
     * @property {string|null} [barrierPrice] OrderReceived barrierPrice
     * @property {string|null} [orderPrice] OrderReceived orderPrice
     * @property {string|null} [profitRealizationBarrierPrice] OrderReceived profitRealizationBarrierPrice
     * @property {string|null} [lossCutBarrierPrice] OrderReceived lossCutBarrierPrice
     * @property {string|null} [orderBalance] OrderReceived orderBalance
     * @property {string|null} [orderStatusCd] OrderReceived orderStatusCd
     * @property {string|null} [isProfitExecution] OrderReceived isProfitExecution
     * @property {string|null} [isLossLimits] OrderReceived isLossLimits
     * @property {string|null} [isLossTracing] OrderReceived isLossTracing
     * @property {string|null} [purchaseDateTime] OrderReceived purchaseDateTime
     * @property {string|null} [balanceNo] OrderReceived balanceNo
     * @property {string|null} [depositAssets] OrderReceived depositAssets
     * @property {string|null} [totalMargin] OrderReceived totalMargin
     * @property {string|null} [isTickerMessage] OrderReceived isTickerMessage
     * @property {string|null} [orderCd] OrderReceived orderCd
     * @property {string|null} [purchasePrice] OrderReceived purchasePrice
     * @property {string|null} [firstLossTrackingPrice] OrderReceived firstLossTrackingPrice
     * @property {string|null} [firstLossCutPrice] OrderReceived firstLossCutPrice
     */

    /**
     * Constructs a new OrderReceived.
     * @exports OrderReceived
     * @classdesc Represents an OrderReceived.
     * @implements IOrderReceived
     * @constructor
     * @param {IOrderReceived=} [properties] Properties to set
     */
    function OrderReceived(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderReceived accountNo.
     * @member {string} accountNo
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.accountNo = "";

    /**
     * OrderReceived orderDateTime.
     * @member {string} orderDateTime
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderDateTime = "";

    /**
     * OrderReceived orderNo.
     * @member {string} orderNo
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderNo = "";

    /**
     * OrderReceived stockCd.
     * @member {string} stockCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.stockCd = "";

    /**
     * OrderReceived orderVersionCd.
     * @member {string} orderVersionCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderVersionCd = "";

    /**
     * OrderReceived positionCd.
     * @member {string} positionCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.positionCd = "";

    /**
     * OrderReceived orderTypeCd.
     * @member {string} orderTypeCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderTypeCd = "";

    /**
     * OrderReceived sideCd.
     * @member {string} sideCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.sideCd = "";

    /**
     * OrderReceived orderQuantity.
     * @member {string} orderQuantity
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderQuantity = "";

    /**
     * OrderReceived barrierPrice.
     * @member {string} barrierPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.barrierPrice = "";

    /**
     * OrderReceived orderPrice.
     * @member {string} orderPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderPrice = "";

    /**
     * OrderReceived profitRealizationBarrierPrice.
     * @member {string} profitRealizationBarrierPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.profitRealizationBarrierPrice = "";

    /**
     * OrderReceived lossCutBarrierPrice.
     * @member {string} lossCutBarrierPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.lossCutBarrierPrice = "";

    /**
     * OrderReceived orderBalance.
     * @member {string} orderBalance
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderBalance = "";

    /**
     * OrderReceived orderStatusCd.
     * @member {string} orderStatusCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderStatusCd = "";

    /**
     * OrderReceived isProfitExecution.
     * @member {string} isProfitExecution
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.isProfitExecution = "";

    /**
     * OrderReceived isLossLimits.
     * @member {string} isLossLimits
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.isLossLimits = "";

    /**
     * OrderReceived isLossTracing.
     * @member {string} isLossTracing
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.isLossTracing = "";

    /**
     * OrderReceived purchaseDateTime.
     * @member {string} purchaseDateTime
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.purchaseDateTime = "";

    /**
     * OrderReceived balanceNo.
     * @member {string} balanceNo
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.balanceNo = "";

    /**
     * OrderReceived depositAssets.
     * @member {string} depositAssets
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.depositAssets = "";

    /**
     * OrderReceived totalMargin.
     * @member {string} totalMargin
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.totalMargin = "";

    /**
     * OrderReceived isTickerMessage.
     * @member {string} isTickerMessage
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.isTickerMessage = "";

    /**
     * OrderReceived orderCd.
     * @member {string} orderCd
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.orderCd = "";

    /**
     * OrderReceived purchasePrice.
     * @member {string} purchasePrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.purchasePrice = "";

    /**
     * OrderReceived firstLossTrackingPrice.
     * @member {string} firstLossTrackingPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.firstLossTrackingPrice = "";

    /**
     * OrderReceived firstLossCutPrice.
     * @member {string} firstLossCutPrice
     * @memberof OrderReceived
     * @instance
     */
    OrderReceived.prototype.firstLossCutPrice = "";

    /**
     * Creates a new OrderReceived instance using the specified properties.
     * @function create
     * @memberof OrderReceived
     * @static
     * @param {IOrderReceived=} [properties] Properties to set
     * @returns {OrderReceived} OrderReceived instance
     */
    OrderReceived.create = function create(properties) {
        return new OrderReceived(properties);
    };

    /**
     * Encodes the specified OrderReceived message. Does not implicitly {@link OrderReceived.verify|verify} messages.
     * @function encode
     * @memberof OrderReceived
     * @static
     * @param {IOrderReceived} message OrderReceived message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderReceived.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.orderDateTime != null && Object.hasOwnProperty.call(message, "orderDateTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderDateTime);
        if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderNo);
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stockCd);
        if (message.orderVersionCd != null && Object.hasOwnProperty.call(message, "orderVersionCd"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.orderVersionCd);
        if (message.positionCd != null && Object.hasOwnProperty.call(message, "positionCd"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.positionCd);
        if (message.orderTypeCd != null && Object.hasOwnProperty.call(message, "orderTypeCd"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderTypeCd);
        if (message.sideCd != null && Object.hasOwnProperty.call(message, "sideCd"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.sideCd);
        if (message.orderQuantity != null && Object.hasOwnProperty.call(message, "orderQuantity"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.orderQuantity);
        if (message.barrierPrice != null && Object.hasOwnProperty.call(message, "barrierPrice"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.barrierPrice);
        if (message.orderPrice != null && Object.hasOwnProperty.call(message, "orderPrice"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.orderPrice);
        if (message.profitRealizationBarrierPrice != null && Object.hasOwnProperty.call(message, "profitRealizationBarrierPrice"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.profitRealizationBarrierPrice);
        if (message.lossCutBarrierPrice != null && Object.hasOwnProperty.call(message, "lossCutBarrierPrice"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.lossCutBarrierPrice);
        if (message.orderBalance != null && Object.hasOwnProperty.call(message, "orderBalance"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.orderBalance);
        if (message.orderStatusCd != null && Object.hasOwnProperty.call(message, "orderStatusCd"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.orderStatusCd);
        if (message.isProfitExecution != null && Object.hasOwnProperty.call(message, "isProfitExecution"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.isProfitExecution);
        if (message.isLossLimits != null && Object.hasOwnProperty.call(message, "isLossLimits"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.isLossLimits);
        if (message.isLossTracing != null && Object.hasOwnProperty.call(message, "isLossTracing"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.isLossTracing);
        if (message.purchaseDateTime != null && Object.hasOwnProperty.call(message, "purchaseDateTime"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.purchaseDateTime);
        if (message.balanceNo != null && Object.hasOwnProperty.call(message, "balanceNo"))
            writer.uint32(/* id 20, wireType 2 =*/162).string(message.balanceNo);
        if (message.depositAssets != null && Object.hasOwnProperty.call(message, "depositAssets"))
            writer.uint32(/* id 21, wireType 2 =*/170).string(message.depositAssets);
        if (message.totalMargin != null && Object.hasOwnProperty.call(message, "totalMargin"))
            writer.uint32(/* id 22, wireType 2 =*/178).string(message.totalMargin);
        if (message.isTickerMessage != null && Object.hasOwnProperty.call(message, "isTickerMessage"))
            writer.uint32(/* id 23, wireType 2 =*/186).string(message.isTickerMessage);
        if (message.orderCd != null && Object.hasOwnProperty.call(message, "orderCd"))
            writer.uint32(/* id 24, wireType 2 =*/194).string(message.orderCd);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            writer.uint32(/* id 25, wireType 2 =*/202).string(message.purchasePrice);
        if (message.firstLossTrackingPrice != null && Object.hasOwnProperty.call(message, "firstLossTrackingPrice"))
            writer.uint32(/* id 26, wireType 2 =*/210).string(message.firstLossTrackingPrice);
        if (message.firstLossCutPrice != null && Object.hasOwnProperty.call(message, "firstLossCutPrice"))
            writer.uint32(/* id 27, wireType 2 =*/218).string(message.firstLossCutPrice);
        return writer;
    };

    /**
     * Encodes the specified OrderReceived message, length delimited. Does not implicitly {@link OrderReceived.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderReceived
     * @static
     * @param {IOrderReceived} message OrderReceived message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderReceived.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderReceived message from the specified reader or buffer.
     * @function decode
     * @memberof OrderReceived
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderReceived} OrderReceived
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderReceived.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderReceived();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.orderDateTime = reader.string();
                    break;
                }
            case 3: {
                    message.orderNo = reader.string();
                    break;
                }
            case 4: {
                    message.stockCd = reader.string();
                    break;
                }
            case 5: {
                    message.orderVersionCd = reader.string();
                    break;
                }
            case 6: {
                    message.positionCd = reader.string();
                    break;
                }
            case 7: {
                    message.orderTypeCd = reader.string();
                    break;
                }
            case 8: {
                    message.sideCd = reader.string();
                    break;
                }
            case 9: {
                    message.orderQuantity = reader.string();
                    break;
                }
            case 10: {
                    message.barrierPrice = reader.string();
                    break;
                }
            case 11: {
                    message.orderPrice = reader.string();
                    break;
                }
            case 12: {
                    message.profitRealizationBarrierPrice = reader.string();
                    break;
                }
            case 13: {
                    message.lossCutBarrierPrice = reader.string();
                    break;
                }
            case 14: {
                    message.orderBalance = reader.string();
                    break;
                }
            case 15: {
                    message.orderStatusCd = reader.string();
                    break;
                }
            case 16: {
                    message.isProfitExecution = reader.string();
                    break;
                }
            case 17: {
                    message.isLossLimits = reader.string();
                    break;
                }
            case 18: {
                    message.isLossTracing = reader.string();
                    break;
                }
            case 19: {
                    message.purchaseDateTime = reader.string();
                    break;
                }
            case 20: {
                    message.balanceNo = reader.string();
                    break;
                }
            case 21: {
                    message.depositAssets = reader.string();
                    break;
                }
            case 22: {
                    message.totalMargin = reader.string();
                    break;
                }
            case 23: {
                    message.isTickerMessage = reader.string();
                    break;
                }
            case 24: {
                    message.orderCd = reader.string();
                    break;
                }
            case 25: {
                    message.purchasePrice = reader.string();
                    break;
                }
            case 26: {
                    message.firstLossTrackingPrice = reader.string();
                    break;
                }
            case 27: {
                    message.firstLossCutPrice = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderReceived message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderReceived
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderReceived} OrderReceived
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderReceived.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderReceived message.
     * @function verify
     * @memberof OrderReceived
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderReceived.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            if (!$util.isString(message.orderDateTime))
                return "orderDateTime: string expected";
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            if (!$util.isString(message.orderNo))
                return "orderNo: string expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.orderVersionCd != null && message.hasOwnProperty("orderVersionCd"))
            if (!$util.isString(message.orderVersionCd))
                return "orderVersionCd: string expected";
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            if (!$util.isString(message.positionCd))
                return "positionCd: string expected";
        if (message.orderTypeCd != null && message.hasOwnProperty("orderTypeCd"))
            if (!$util.isString(message.orderTypeCd))
                return "orderTypeCd: string expected";
        if (message.sideCd != null && message.hasOwnProperty("sideCd"))
            if (!$util.isString(message.sideCd))
                return "sideCd: string expected";
        if (message.orderQuantity != null && message.hasOwnProperty("orderQuantity"))
            if (!$util.isString(message.orderQuantity))
                return "orderQuantity: string expected";
        if (message.barrierPrice != null && message.hasOwnProperty("barrierPrice"))
            if (!$util.isString(message.barrierPrice))
                return "barrierPrice: string expected";
        if (message.orderPrice != null && message.hasOwnProperty("orderPrice"))
            if (!$util.isString(message.orderPrice))
                return "orderPrice: string expected";
        if (message.profitRealizationBarrierPrice != null && message.hasOwnProperty("profitRealizationBarrierPrice"))
            if (!$util.isString(message.profitRealizationBarrierPrice))
                return "profitRealizationBarrierPrice: string expected";
        if (message.lossCutBarrierPrice != null && message.hasOwnProperty("lossCutBarrierPrice"))
            if (!$util.isString(message.lossCutBarrierPrice))
                return "lossCutBarrierPrice: string expected";
        if (message.orderBalance != null && message.hasOwnProperty("orderBalance"))
            if (!$util.isString(message.orderBalance))
                return "orderBalance: string expected";
        if (message.orderStatusCd != null && message.hasOwnProperty("orderStatusCd"))
            if (!$util.isString(message.orderStatusCd))
                return "orderStatusCd: string expected";
        if (message.isProfitExecution != null && message.hasOwnProperty("isProfitExecution"))
            if (!$util.isString(message.isProfitExecution))
                return "isProfitExecution: string expected";
        if (message.isLossLimits != null && message.hasOwnProperty("isLossLimits"))
            if (!$util.isString(message.isLossLimits))
                return "isLossLimits: string expected";
        if (message.isLossTracing != null && message.hasOwnProperty("isLossTracing"))
            if (!$util.isString(message.isLossTracing))
                return "isLossTracing: string expected";
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            if (!$util.isString(message.purchaseDateTime))
                return "purchaseDateTime: string expected";
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            if (!$util.isString(message.balanceNo))
                return "balanceNo: string expected";
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            if (!$util.isString(message.depositAssets))
                return "depositAssets: string expected";
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            if (!$util.isString(message.totalMargin))
                return "totalMargin: string expected";
        if (message.isTickerMessage != null && message.hasOwnProperty("isTickerMessage"))
            if (!$util.isString(message.isTickerMessage))
                return "isTickerMessage: string expected";
        if (message.orderCd != null && message.hasOwnProperty("orderCd"))
            if (!$util.isString(message.orderCd))
                return "orderCd: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            if (!$util.isString(message.purchasePrice))
                return "purchasePrice: string expected";
        if (message.firstLossTrackingPrice != null && message.hasOwnProperty("firstLossTrackingPrice"))
            if (!$util.isString(message.firstLossTrackingPrice))
                return "firstLossTrackingPrice: string expected";
        if (message.firstLossCutPrice != null && message.hasOwnProperty("firstLossCutPrice"))
            if (!$util.isString(message.firstLossCutPrice))
                return "firstLossCutPrice: string expected";
        return null;
    };

    /**
     * Creates an OrderReceived message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderReceived
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderReceived} OrderReceived
     */
    OrderReceived.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderReceived)
            return object;
        let message = new $root.OrderReceived();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.orderDateTime != null)
            message.orderDateTime = String(object.orderDateTime);
        if (object.orderNo != null)
            message.orderNo = String(object.orderNo);
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.orderVersionCd != null)
            message.orderVersionCd = String(object.orderVersionCd);
        if (object.positionCd != null)
            message.positionCd = String(object.positionCd);
        if (object.orderTypeCd != null)
            message.orderTypeCd = String(object.orderTypeCd);
        if (object.sideCd != null)
            message.sideCd = String(object.sideCd);
        if (object.orderQuantity != null)
            message.orderQuantity = String(object.orderQuantity);
        if (object.barrierPrice != null)
            message.barrierPrice = String(object.barrierPrice);
        if (object.orderPrice != null)
            message.orderPrice = String(object.orderPrice);
        if (object.profitRealizationBarrierPrice != null)
            message.profitRealizationBarrierPrice = String(object.profitRealizationBarrierPrice);
        if (object.lossCutBarrierPrice != null)
            message.lossCutBarrierPrice = String(object.lossCutBarrierPrice);
        if (object.orderBalance != null)
            message.orderBalance = String(object.orderBalance);
        if (object.orderStatusCd != null)
            message.orderStatusCd = String(object.orderStatusCd);
        if (object.isProfitExecution != null)
            message.isProfitExecution = String(object.isProfitExecution);
        if (object.isLossLimits != null)
            message.isLossLimits = String(object.isLossLimits);
        if (object.isLossTracing != null)
            message.isLossTracing = String(object.isLossTracing);
        if (object.purchaseDateTime != null)
            message.purchaseDateTime = String(object.purchaseDateTime);
        if (object.balanceNo != null)
            message.balanceNo = String(object.balanceNo);
        if (object.depositAssets != null)
            message.depositAssets = String(object.depositAssets);
        if (object.totalMargin != null)
            message.totalMargin = String(object.totalMargin);
        if (object.isTickerMessage != null)
            message.isTickerMessage = String(object.isTickerMessage);
        if (object.orderCd != null)
            message.orderCd = String(object.orderCd);
        if (object.purchasePrice != null)
            message.purchasePrice = String(object.purchasePrice);
        if (object.firstLossTrackingPrice != null)
            message.firstLossTrackingPrice = String(object.firstLossTrackingPrice);
        if (object.firstLossCutPrice != null)
            message.firstLossCutPrice = String(object.firstLossCutPrice);
        return message;
    };

    /**
     * Creates a plain object from an OrderReceived message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderReceived
     * @static
     * @param {OrderReceived} message OrderReceived
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderReceived.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.orderDateTime = "";
            object.orderNo = "";
            object.stockCd = "";
            object.orderVersionCd = "";
            object.positionCd = "";
            object.orderTypeCd = "";
            object.sideCd = "";
            object.orderQuantity = "";
            object.barrierPrice = "";
            object.orderPrice = "";
            object.profitRealizationBarrierPrice = "";
            object.lossCutBarrierPrice = "";
            object.orderBalance = "";
            object.orderStatusCd = "";
            object.isProfitExecution = "";
            object.isLossLimits = "";
            object.isLossTracing = "";
            object.purchaseDateTime = "";
            object.balanceNo = "";
            object.depositAssets = "";
            object.totalMargin = "";
            object.isTickerMessage = "";
            object.orderCd = "";
            object.purchasePrice = "";
            object.firstLossTrackingPrice = "";
            object.firstLossCutPrice = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            object.orderDateTime = message.orderDateTime;
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            object.orderNo = message.orderNo;
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.orderVersionCd != null && message.hasOwnProperty("orderVersionCd"))
            object.orderVersionCd = message.orderVersionCd;
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            object.positionCd = message.positionCd;
        if (message.orderTypeCd != null && message.hasOwnProperty("orderTypeCd"))
            object.orderTypeCd = message.orderTypeCd;
        if (message.sideCd != null && message.hasOwnProperty("sideCd"))
            object.sideCd = message.sideCd;
        if (message.orderQuantity != null && message.hasOwnProperty("orderQuantity"))
            object.orderQuantity = message.orderQuantity;
        if (message.barrierPrice != null && message.hasOwnProperty("barrierPrice"))
            object.barrierPrice = message.barrierPrice;
        if (message.orderPrice != null && message.hasOwnProperty("orderPrice"))
            object.orderPrice = message.orderPrice;
        if (message.profitRealizationBarrierPrice != null && message.hasOwnProperty("profitRealizationBarrierPrice"))
            object.profitRealizationBarrierPrice = message.profitRealizationBarrierPrice;
        if (message.lossCutBarrierPrice != null && message.hasOwnProperty("lossCutBarrierPrice"))
            object.lossCutBarrierPrice = message.lossCutBarrierPrice;
        if (message.orderBalance != null && message.hasOwnProperty("orderBalance"))
            object.orderBalance = message.orderBalance;
        if (message.orderStatusCd != null && message.hasOwnProperty("orderStatusCd"))
            object.orderStatusCd = message.orderStatusCd;
        if (message.isProfitExecution != null && message.hasOwnProperty("isProfitExecution"))
            object.isProfitExecution = message.isProfitExecution;
        if (message.isLossLimits != null && message.hasOwnProperty("isLossLimits"))
            object.isLossLimits = message.isLossLimits;
        if (message.isLossTracing != null && message.hasOwnProperty("isLossTracing"))
            object.isLossTracing = message.isLossTracing;
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            object.purchaseDateTime = message.purchaseDateTime;
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            object.balanceNo = message.balanceNo;
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            object.depositAssets = message.depositAssets;
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            object.totalMargin = message.totalMargin;
        if (message.isTickerMessage != null && message.hasOwnProperty("isTickerMessage"))
            object.isTickerMessage = message.isTickerMessage;
        if (message.orderCd != null && message.hasOwnProperty("orderCd"))
            object.orderCd = message.orderCd;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = message.purchasePrice;
        if (message.firstLossTrackingPrice != null && message.hasOwnProperty("firstLossTrackingPrice"))
            object.firstLossTrackingPrice = message.firstLossTrackingPrice;
        if (message.firstLossCutPrice != null && message.hasOwnProperty("firstLossCutPrice"))
            object.firstLossCutPrice = message.firstLossCutPrice;
        return object;
    };

    /**
     * Converts this OrderReceived to JSON.
     * @function toJSON
     * @memberof OrderReceived
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderReceived.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderReceived
     * @function getTypeUrl
     * @memberof OrderReceived
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderReceived.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderReceived";
    };

    return OrderReceived;
})();

export const OrderRejected = $root.OrderRejected = (() => {

    /**
     * Properties of an OrderRejected.
     * @exports IOrderRejected
     * @interface IOrderRejected
     * @property {string|null} [accountNo] OrderRejected accountNo
     * @property {string|null} [orderDateTime] OrderRejected orderDateTime
     * @property {string|null} [orderNo] OrderRejected orderNo
     * @property {string|null} [stockCd] OrderRejected stockCd
     * @property {string|null} [positionCd] OrderRejected positionCd
     * @property {string|null} [sideCd] OrderRejected sideCd
     * @property {string|null} [rejectQuantity] OrderRejected rejectQuantity
     * @property {string|null} [purchaseDateTime] OrderRejected purchaseDateTime
     * @property {string|null} [balanceNo] OrderRejected balanceNo
     * @property {string|null} [depositAssets] OrderRejected depositAssets
     * @property {string|null} [totalMargin] OrderRejected totalMargin
     * @property {string|null} [orderCd] OrderRejected orderCd
     */

    /**
     * Constructs a new OrderRejected.
     * @exports OrderRejected
     * @classdesc Represents an OrderRejected.
     * @implements IOrderRejected
     * @constructor
     * @param {IOrderRejected=} [properties] Properties to set
     */
    function OrderRejected(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderRejected accountNo.
     * @member {string} accountNo
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.accountNo = "";

    /**
     * OrderRejected orderDateTime.
     * @member {string} orderDateTime
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.orderDateTime = "";

    /**
     * OrderRejected orderNo.
     * @member {string} orderNo
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.orderNo = "";

    /**
     * OrderRejected stockCd.
     * @member {string} stockCd
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.stockCd = "";

    /**
     * OrderRejected positionCd.
     * @member {string} positionCd
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.positionCd = "";

    /**
     * OrderRejected sideCd.
     * @member {string} sideCd
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.sideCd = "";

    /**
     * OrderRejected rejectQuantity.
     * @member {string} rejectQuantity
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.rejectQuantity = "";

    /**
     * OrderRejected purchaseDateTime.
     * @member {string} purchaseDateTime
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.purchaseDateTime = "";

    /**
     * OrderRejected balanceNo.
     * @member {string} balanceNo
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.balanceNo = "";

    /**
     * OrderRejected depositAssets.
     * @member {string} depositAssets
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.depositAssets = "";

    /**
     * OrderRejected totalMargin.
     * @member {string} totalMargin
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.totalMargin = "";

    /**
     * OrderRejected orderCd.
     * @member {string} orderCd
     * @memberof OrderRejected
     * @instance
     */
    OrderRejected.prototype.orderCd = "";

    /**
     * Creates a new OrderRejected instance using the specified properties.
     * @function create
     * @memberof OrderRejected
     * @static
     * @param {IOrderRejected=} [properties] Properties to set
     * @returns {OrderRejected} OrderRejected instance
     */
    OrderRejected.create = function create(properties) {
        return new OrderRejected(properties);
    };

    /**
     * Encodes the specified OrderRejected message. Does not implicitly {@link OrderRejected.verify|verify} messages.
     * @function encode
     * @memberof OrderRejected
     * @static
     * @param {IOrderRejected} message OrderRejected message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderRejected.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.orderDateTime != null && Object.hasOwnProperty.call(message, "orderDateTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderDateTime);
        if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderNo);
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stockCd);
        if (message.positionCd != null && Object.hasOwnProperty.call(message, "positionCd"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.positionCd);
        if (message.sideCd != null && Object.hasOwnProperty.call(message, "sideCd"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.sideCd);
        if (message.rejectQuantity != null && Object.hasOwnProperty.call(message, "rejectQuantity"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.rejectQuantity);
        if (message.purchaseDateTime != null && Object.hasOwnProperty.call(message, "purchaseDateTime"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.purchaseDateTime);
        if (message.balanceNo != null && Object.hasOwnProperty.call(message, "balanceNo"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.balanceNo);
        if (message.depositAssets != null && Object.hasOwnProperty.call(message, "depositAssets"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.depositAssets);
        if (message.totalMargin != null && Object.hasOwnProperty.call(message, "totalMargin"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.totalMargin);
        if (message.orderCd != null && Object.hasOwnProperty.call(message, "orderCd"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.orderCd);
        return writer;
    };

    /**
     * Encodes the specified OrderRejected message, length delimited. Does not implicitly {@link OrderRejected.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderRejected
     * @static
     * @param {IOrderRejected} message OrderRejected message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderRejected.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderRejected message from the specified reader or buffer.
     * @function decode
     * @memberof OrderRejected
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderRejected} OrderRejected
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderRejected.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderRejected();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.orderDateTime = reader.string();
                    break;
                }
            case 3: {
                    message.orderNo = reader.string();
                    break;
                }
            case 4: {
                    message.stockCd = reader.string();
                    break;
                }
            case 5: {
                    message.positionCd = reader.string();
                    break;
                }
            case 6: {
                    message.sideCd = reader.string();
                    break;
                }
            case 7: {
                    message.rejectQuantity = reader.string();
                    break;
                }
            case 8: {
                    message.purchaseDateTime = reader.string();
                    break;
                }
            case 9: {
                    message.balanceNo = reader.string();
                    break;
                }
            case 10: {
                    message.depositAssets = reader.string();
                    break;
                }
            case 11: {
                    message.totalMargin = reader.string();
                    break;
                }
            case 12: {
                    message.orderCd = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderRejected message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderRejected
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderRejected} OrderRejected
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderRejected.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderRejected message.
     * @function verify
     * @memberof OrderRejected
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderRejected.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            if (!$util.isString(message.orderDateTime))
                return "orderDateTime: string expected";
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            if (!$util.isString(message.orderNo))
                return "orderNo: string expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            if (!$util.isString(message.positionCd))
                return "positionCd: string expected";
        if (message.sideCd != null && message.hasOwnProperty("sideCd"))
            if (!$util.isString(message.sideCd))
                return "sideCd: string expected";
        if (message.rejectQuantity != null && message.hasOwnProperty("rejectQuantity"))
            if (!$util.isString(message.rejectQuantity))
                return "rejectQuantity: string expected";
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            if (!$util.isString(message.purchaseDateTime))
                return "purchaseDateTime: string expected";
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            if (!$util.isString(message.balanceNo))
                return "balanceNo: string expected";
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            if (!$util.isString(message.depositAssets))
                return "depositAssets: string expected";
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            if (!$util.isString(message.totalMargin))
                return "totalMargin: string expected";
        if (message.orderCd != null && message.hasOwnProperty("orderCd"))
            if (!$util.isString(message.orderCd))
                return "orderCd: string expected";
        return null;
    };

    /**
     * Creates an OrderRejected message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderRejected
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderRejected} OrderRejected
     */
    OrderRejected.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderRejected)
            return object;
        let message = new $root.OrderRejected();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.orderDateTime != null)
            message.orderDateTime = String(object.orderDateTime);
        if (object.orderNo != null)
            message.orderNo = String(object.orderNo);
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.positionCd != null)
            message.positionCd = String(object.positionCd);
        if (object.sideCd != null)
            message.sideCd = String(object.sideCd);
        if (object.rejectQuantity != null)
            message.rejectQuantity = String(object.rejectQuantity);
        if (object.purchaseDateTime != null)
            message.purchaseDateTime = String(object.purchaseDateTime);
        if (object.balanceNo != null)
            message.balanceNo = String(object.balanceNo);
        if (object.depositAssets != null)
            message.depositAssets = String(object.depositAssets);
        if (object.totalMargin != null)
            message.totalMargin = String(object.totalMargin);
        if (object.orderCd != null)
            message.orderCd = String(object.orderCd);
        return message;
    };

    /**
     * Creates a plain object from an OrderRejected message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderRejected
     * @static
     * @param {OrderRejected} message OrderRejected
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderRejected.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.orderDateTime = "";
            object.orderNo = "";
            object.stockCd = "";
            object.positionCd = "";
            object.sideCd = "";
            object.rejectQuantity = "";
            object.purchaseDateTime = "";
            object.balanceNo = "";
            object.depositAssets = "";
            object.totalMargin = "";
            object.orderCd = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            object.orderDateTime = message.orderDateTime;
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            object.orderNo = message.orderNo;
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            object.positionCd = message.positionCd;
        if (message.sideCd != null && message.hasOwnProperty("sideCd"))
            object.sideCd = message.sideCd;
        if (message.rejectQuantity != null && message.hasOwnProperty("rejectQuantity"))
            object.rejectQuantity = message.rejectQuantity;
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            object.purchaseDateTime = message.purchaseDateTime;
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            object.balanceNo = message.balanceNo;
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            object.depositAssets = message.depositAssets;
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            object.totalMargin = message.totalMargin;
        if (message.orderCd != null && message.hasOwnProperty("orderCd"))
            object.orderCd = message.orderCd;
        return object;
    };

    /**
     * Converts this OrderRejected to JSON.
     * @function toJSON
     * @memberof OrderRejected
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderRejected.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderRejected
     * @function getTypeUrl
     * @memberof OrderRejected
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderRejected.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderRejected";
    };

    return OrderRejected;
})();

export const OrderExecuted = $root.OrderExecuted = (() => {

    /**
     * Properties of an OrderExecuted.
     * @exports IOrderExecuted
     * @interface IOrderExecuted
     * @property {string|null} [accountNo] OrderExecuted accountNo
     * @property {string|null} [orderDateTime] OrderExecuted orderDateTime
     * @property {string|null} [orderNo] OrderExecuted orderNo
     * @property {string|null} [executionQuantity] OrderExecuted executionQuantity
     * @property {string|null} [executionPrice] OrderExecuted executionPrice
     * @property {string|null} [depositAssets] OrderExecuted depositAssets
     * @property {string|null} [totalMargin] OrderExecuted totalMargin
     */

    /**
     * Constructs a new OrderExecuted.
     * @exports OrderExecuted
     * @classdesc Represents an OrderExecuted.
     * @implements IOrderExecuted
     * @constructor
     * @param {IOrderExecuted=} [properties] Properties to set
     */
    function OrderExecuted(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderExecuted accountNo.
     * @member {string} accountNo
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.accountNo = "";

    /**
     * OrderExecuted orderDateTime.
     * @member {string} orderDateTime
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.orderDateTime = "";

    /**
     * OrderExecuted orderNo.
     * @member {string} orderNo
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.orderNo = "";

    /**
     * OrderExecuted executionQuantity.
     * @member {string} executionQuantity
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.executionQuantity = "";

    /**
     * OrderExecuted executionPrice.
     * @member {string} executionPrice
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.executionPrice = "";

    /**
     * OrderExecuted depositAssets.
     * @member {string} depositAssets
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.depositAssets = "";

    /**
     * OrderExecuted totalMargin.
     * @member {string} totalMargin
     * @memberof OrderExecuted
     * @instance
     */
    OrderExecuted.prototype.totalMargin = "";

    /**
     * Creates a new OrderExecuted instance using the specified properties.
     * @function create
     * @memberof OrderExecuted
     * @static
     * @param {IOrderExecuted=} [properties] Properties to set
     * @returns {OrderExecuted} OrderExecuted instance
     */
    OrderExecuted.create = function create(properties) {
        return new OrderExecuted(properties);
    };

    /**
     * Encodes the specified OrderExecuted message. Does not implicitly {@link OrderExecuted.verify|verify} messages.
     * @function encode
     * @memberof OrderExecuted
     * @static
     * @param {IOrderExecuted} message OrderExecuted message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderExecuted.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.orderDateTime != null && Object.hasOwnProperty.call(message, "orderDateTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderDateTime);
        if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderNo);
        if (message.executionQuantity != null && Object.hasOwnProperty.call(message, "executionQuantity"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.executionQuantity);
        if (message.executionPrice != null && Object.hasOwnProperty.call(message, "executionPrice"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.executionPrice);
        if (message.depositAssets != null && Object.hasOwnProperty.call(message, "depositAssets"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.depositAssets);
        if (message.totalMargin != null && Object.hasOwnProperty.call(message, "totalMargin"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.totalMargin);
        return writer;
    };

    /**
     * Encodes the specified OrderExecuted message, length delimited. Does not implicitly {@link OrderExecuted.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderExecuted
     * @static
     * @param {IOrderExecuted} message OrderExecuted message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderExecuted.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderExecuted message from the specified reader or buffer.
     * @function decode
     * @memberof OrderExecuted
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderExecuted} OrderExecuted
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderExecuted.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderExecuted();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.orderDateTime = reader.string();
                    break;
                }
            case 3: {
                    message.orderNo = reader.string();
                    break;
                }
            case 4: {
                    message.executionQuantity = reader.string();
                    break;
                }
            case 5: {
                    message.executionPrice = reader.string();
                    break;
                }
            case 6: {
                    message.depositAssets = reader.string();
                    break;
                }
            case 7: {
                    message.totalMargin = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderExecuted message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderExecuted
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderExecuted} OrderExecuted
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderExecuted.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderExecuted message.
     * @function verify
     * @memberof OrderExecuted
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderExecuted.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            if (!$util.isString(message.orderDateTime))
                return "orderDateTime: string expected";
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            if (!$util.isString(message.orderNo))
                return "orderNo: string expected";
        if (message.executionQuantity != null && message.hasOwnProperty("executionQuantity"))
            if (!$util.isString(message.executionQuantity))
                return "executionQuantity: string expected";
        if (message.executionPrice != null && message.hasOwnProperty("executionPrice"))
            if (!$util.isString(message.executionPrice))
                return "executionPrice: string expected";
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            if (!$util.isString(message.depositAssets))
                return "depositAssets: string expected";
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            if (!$util.isString(message.totalMargin))
                return "totalMargin: string expected";
        return null;
    };

    /**
     * Creates an OrderExecuted message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderExecuted
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderExecuted} OrderExecuted
     */
    OrderExecuted.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderExecuted)
            return object;
        let message = new $root.OrderExecuted();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.orderDateTime != null)
            message.orderDateTime = String(object.orderDateTime);
        if (object.orderNo != null)
            message.orderNo = String(object.orderNo);
        if (object.executionQuantity != null)
            message.executionQuantity = String(object.executionQuantity);
        if (object.executionPrice != null)
            message.executionPrice = String(object.executionPrice);
        if (object.depositAssets != null)
            message.depositAssets = String(object.depositAssets);
        if (object.totalMargin != null)
            message.totalMargin = String(object.totalMargin);
        return message;
    };

    /**
     * Creates a plain object from an OrderExecuted message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderExecuted
     * @static
     * @param {OrderExecuted} message OrderExecuted
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderExecuted.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.orderDateTime = "";
            object.orderNo = "";
            object.executionQuantity = "";
            object.executionPrice = "";
            object.depositAssets = "";
            object.totalMargin = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            object.orderDateTime = message.orderDateTime;
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            object.orderNo = message.orderNo;
        if (message.executionQuantity != null && message.hasOwnProperty("executionQuantity"))
            object.executionQuantity = message.executionQuantity;
        if (message.executionPrice != null && message.hasOwnProperty("executionPrice"))
            object.executionPrice = message.executionPrice;
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            object.depositAssets = message.depositAssets;
        if (message.totalMargin != null && message.hasOwnProperty("totalMargin"))
            object.totalMargin = message.totalMargin;
        return object;
    };

    /**
     * Converts this OrderExecuted to JSON.
     * @function toJSON
     * @memberof OrderExecuted
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderExecuted.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderExecuted
     * @function getTypeUrl
     * @memberof OrderExecuted
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderExecuted.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderExecuted";
    };

    return OrderExecuted;
})();

export const BalanceUpdated = $root.BalanceUpdated = (() => {

    /**
     * Properties of a BalanceUpdated.
     * @exports IBalanceUpdated
     * @interface IBalanceUpdated
     * @property {string|null} [accountNo] BalanceUpdated accountNo
     * @property {string|null} [orderDateTime] BalanceUpdated orderDateTime
     * @property {string|null} [orderNo] BalanceUpdated orderNo
     * @property {string|null} [stockCd] BalanceUpdated stockCd
     * @property {string|null} [tradeCurrencyCd] BalanceUpdated tradeCurrencyCd
     * @property {string|null} [positionCd] BalanceUpdated positionCd
     * @property {string|null} [purchaseDateTime] BalanceUpdated purchaseDateTime
     * @property {string|null} [bookQuantity] BalanceUpdated bookQuantity
     * @property {string|null} [liquidationPossibleQuantity] BalanceUpdated liquidationPossibleQuantity
     * @property {string|null} [bookPrice] BalanceUpdated bookPrice
     * @property {string|null} [currentPrice] BalanceUpdated currentPrice
     * @property {string|null} [evaluationProfitLoss] BalanceUpdated evaluationProfitLoss
     * @property {string|null} [stockGroupCd] BalanceUpdated stockGroupCd
     * @property {string|null} [balanceNo] BalanceUpdated balanceNo
     */

    /**
     * Constructs a new BalanceUpdated.
     * @exports BalanceUpdated
     * @classdesc Represents a BalanceUpdated.
     * @implements IBalanceUpdated
     * @constructor
     * @param {IBalanceUpdated=} [properties] Properties to set
     */
    function BalanceUpdated(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BalanceUpdated accountNo.
     * @member {string} accountNo
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.accountNo = "";

    /**
     * BalanceUpdated orderDateTime.
     * @member {string} orderDateTime
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.orderDateTime = "";

    /**
     * BalanceUpdated orderNo.
     * @member {string} orderNo
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.orderNo = "";

    /**
     * BalanceUpdated stockCd.
     * @member {string} stockCd
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.stockCd = "";

    /**
     * BalanceUpdated tradeCurrencyCd.
     * @member {string} tradeCurrencyCd
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.tradeCurrencyCd = "";

    /**
     * BalanceUpdated positionCd.
     * @member {string} positionCd
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.positionCd = "";

    /**
     * BalanceUpdated purchaseDateTime.
     * @member {string} purchaseDateTime
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.purchaseDateTime = "";

    /**
     * BalanceUpdated bookQuantity.
     * @member {string} bookQuantity
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.bookQuantity = "";

    /**
     * BalanceUpdated liquidationPossibleQuantity.
     * @member {string} liquidationPossibleQuantity
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.liquidationPossibleQuantity = "";

    /**
     * BalanceUpdated bookPrice.
     * @member {string} bookPrice
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.bookPrice = "";

    /**
     * BalanceUpdated currentPrice.
     * @member {string} currentPrice
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.currentPrice = "";

    /**
     * BalanceUpdated evaluationProfitLoss.
     * @member {string} evaluationProfitLoss
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.evaluationProfitLoss = "";

    /**
     * BalanceUpdated stockGroupCd.
     * @member {string} stockGroupCd
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.stockGroupCd = "";

    /**
     * BalanceUpdated balanceNo.
     * @member {string} balanceNo
     * @memberof BalanceUpdated
     * @instance
     */
    BalanceUpdated.prototype.balanceNo = "";

    /**
     * Creates a new BalanceUpdated instance using the specified properties.
     * @function create
     * @memberof BalanceUpdated
     * @static
     * @param {IBalanceUpdated=} [properties] Properties to set
     * @returns {BalanceUpdated} BalanceUpdated instance
     */
    BalanceUpdated.create = function create(properties) {
        return new BalanceUpdated(properties);
    };

    /**
     * Encodes the specified BalanceUpdated message. Does not implicitly {@link BalanceUpdated.verify|verify} messages.
     * @function encode
     * @memberof BalanceUpdated
     * @static
     * @param {IBalanceUpdated} message BalanceUpdated message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BalanceUpdated.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.orderDateTime != null && Object.hasOwnProperty.call(message, "orderDateTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderDateTime);
        if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderNo);
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stockCd);
        if (message.tradeCurrencyCd != null && Object.hasOwnProperty.call(message, "tradeCurrencyCd"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.tradeCurrencyCd);
        if (message.positionCd != null && Object.hasOwnProperty.call(message, "positionCd"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.positionCd);
        if (message.purchaseDateTime != null && Object.hasOwnProperty.call(message, "purchaseDateTime"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.purchaseDateTime);
        if (message.bookQuantity != null && Object.hasOwnProperty.call(message, "bookQuantity"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.bookQuantity);
        if (message.liquidationPossibleQuantity != null && Object.hasOwnProperty.call(message, "liquidationPossibleQuantity"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.liquidationPossibleQuantity);
        if (message.bookPrice != null && Object.hasOwnProperty.call(message, "bookPrice"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.bookPrice);
        if (message.currentPrice != null && Object.hasOwnProperty.call(message, "currentPrice"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.currentPrice);
        if (message.evaluationProfitLoss != null && Object.hasOwnProperty.call(message, "evaluationProfitLoss"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.evaluationProfitLoss);
        if (message.stockGroupCd != null && Object.hasOwnProperty.call(message, "stockGroupCd"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.stockGroupCd);
        if (message.balanceNo != null && Object.hasOwnProperty.call(message, "balanceNo"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.balanceNo);
        return writer;
    };

    /**
     * Encodes the specified BalanceUpdated message, length delimited. Does not implicitly {@link BalanceUpdated.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BalanceUpdated
     * @static
     * @param {IBalanceUpdated} message BalanceUpdated message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BalanceUpdated.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BalanceUpdated message from the specified reader or buffer.
     * @function decode
     * @memberof BalanceUpdated
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BalanceUpdated} BalanceUpdated
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BalanceUpdated.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BalanceUpdated();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.orderDateTime = reader.string();
                    break;
                }
            case 3: {
                    message.orderNo = reader.string();
                    break;
                }
            case 4: {
                    message.stockCd = reader.string();
                    break;
                }
            case 5: {
                    message.tradeCurrencyCd = reader.string();
                    break;
                }
            case 6: {
                    message.positionCd = reader.string();
                    break;
                }
            case 7: {
                    message.purchaseDateTime = reader.string();
                    break;
                }
            case 8: {
                    message.bookQuantity = reader.string();
                    break;
                }
            case 9: {
                    message.liquidationPossibleQuantity = reader.string();
                    break;
                }
            case 10: {
                    message.bookPrice = reader.string();
                    break;
                }
            case 11: {
                    message.currentPrice = reader.string();
                    break;
                }
            case 12: {
                    message.evaluationProfitLoss = reader.string();
                    break;
                }
            case 13: {
                    message.stockGroupCd = reader.string();
                    break;
                }
            case 14: {
                    message.balanceNo = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BalanceUpdated message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BalanceUpdated
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BalanceUpdated} BalanceUpdated
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BalanceUpdated.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BalanceUpdated message.
     * @function verify
     * @memberof BalanceUpdated
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BalanceUpdated.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            if (!$util.isString(message.orderDateTime))
                return "orderDateTime: string expected";
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            if (!$util.isString(message.orderNo))
                return "orderNo: string expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.tradeCurrencyCd != null && message.hasOwnProperty("tradeCurrencyCd"))
            if (!$util.isString(message.tradeCurrencyCd))
                return "tradeCurrencyCd: string expected";
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            if (!$util.isString(message.positionCd))
                return "positionCd: string expected";
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            if (!$util.isString(message.purchaseDateTime))
                return "purchaseDateTime: string expected";
        if (message.bookQuantity != null && message.hasOwnProperty("bookQuantity"))
            if (!$util.isString(message.bookQuantity))
                return "bookQuantity: string expected";
        if (message.liquidationPossibleQuantity != null && message.hasOwnProperty("liquidationPossibleQuantity"))
            if (!$util.isString(message.liquidationPossibleQuantity))
                return "liquidationPossibleQuantity: string expected";
        if (message.bookPrice != null && message.hasOwnProperty("bookPrice"))
            if (!$util.isString(message.bookPrice))
                return "bookPrice: string expected";
        if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
            if (!$util.isString(message.currentPrice))
                return "currentPrice: string expected";
        if (message.evaluationProfitLoss != null && message.hasOwnProperty("evaluationProfitLoss"))
            if (!$util.isString(message.evaluationProfitLoss))
                return "evaluationProfitLoss: string expected";
        if (message.stockGroupCd != null && message.hasOwnProperty("stockGroupCd"))
            if (!$util.isString(message.stockGroupCd))
                return "stockGroupCd: string expected";
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            if (!$util.isString(message.balanceNo))
                return "balanceNo: string expected";
        return null;
    };

    /**
     * Creates a BalanceUpdated message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BalanceUpdated
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BalanceUpdated} BalanceUpdated
     */
    BalanceUpdated.fromObject = function fromObject(object) {
        if (object instanceof $root.BalanceUpdated)
            return object;
        let message = new $root.BalanceUpdated();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.orderDateTime != null)
            message.orderDateTime = String(object.orderDateTime);
        if (object.orderNo != null)
            message.orderNo = String(object.orderNo);
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.tradeCurrencyCd != null)
            message.tradeCurrencyCd = String(object.tradeCurrencyCd);
        if (object.positionCd != null)
            message.positionCd = String(object.positionCd);
        if (object.purchaseDateTime != null)
            message.purchaseDateTime = String(object.purchaseDateTime);
        if (object.bookQuantity != null)
            message.bookQuantity = String(object.bookQuantity);
        if (object.liquidationPossibleQuantity != null)
            message.liquidationPossibleQuantity = String(object.liquidationPossibleQuantity);
        if (object.bookPrice != null)
            message.bookPrice = String(object.bookPrice);
        if (object.currentPrice != null)
            message.currentPrice = String(object.currentPrice);
        if (object.evaluationProfitLoss != null)
            message.evaluationProfitLoss = String(object.evaluationProfitLoss);
        if (object.stockGroupCd != null)
            message.stockGroupCd = String(object.stockGroupCd);
        if (object.balanceNo != null)
            message.balanceNo = String(object.balanceNo);
        return message;
    };

    /**
     * Creates a plain object from a BalanceUpdated message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BalanceUpdated
     * @static
     * @param {BalanceUpdated} message BalanceUpdated
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BalanceUpdated.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.orderDateTime = "";
            object.orderNo = "";
            object.stockCd = "";
            object.tradeCurrencyCd = "";
            object.positionCd = "";
            object.purchaseDateTime = "";
            object.bookQuantity = "";
            object.liquidationPossibleQuantity = "";
            object.bookPrice = "";
            object.currentPrice = "";
            object.evaluationProfitLoss = "";
            object.stockGroupCd = "";
            object.balanceNo = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.orderDateTime != null && message.hasOwnProperty("orderDateTime"))
            object.orderDateTime = message.orderDateTime;
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            object.orderNo = message.orderNo;
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.tradeCurrencyCd != null && message.hasOwnProperty("tradeCurrencyCd"))
            object.tradeCurrencyCd = message.tradeCurrencyCd;
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            object.positionCd = message.positionCd;
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            object.purchaseDateTime = message.purchaseDateTime;
        if (message.bookQuantity != null && message.hasOwnProperty("bookQuantity"))
            object.bookQuantity = message.bookQuantity;
        if (message.liquidationPossibleQuantity != null && message.hasOwnProperty("liquidationPossibleQuantity"))
            object.liquidationPossibleQuantity = message.liquidationPossibleQuantity;
        if (message.bookPrice != null && message.hasOwnProperty("bookPrice"))
            object.bookPrice = message.bookPrice;
        if (message.currentPrice != null && message.hasOwnProperty("currentPrice"))
            object.currentPrice = message.currentPrice;
        if (message.evaluationProfitLoss != null && message.hasOwnProperty("evaluationProfitLoss"))
            object.evaluationProfitLoss = message.evaluationProfitLoss;
        if (message.stockGroupCd != null && message.hasOwnProperty("stockGroupCd"))
            object.stockGroupCd = message.stockGroupCd;
        if (message.balanceNo != null && message.hasOwnProperty("balanceNo"))
            object.balanceNo = message.balanceNo;
        return object;
    };

    /**
     * Converts this BalanceUpdated to JSON.
     * @function toJSON
     * @memberof BalanceUpdated
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BalanceUpdated.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BalanceUpdated
     * @function getTypeUrl
     * @memberof BalanceUpdated
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BalanceUpdated.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BalanceUpdated";
    };

    return BalanceUpdated;
})();

export const DepositUpdated = $root.DepositUpdated = (() => {

    /**
     * Properties of a DepositUpdated.
     * @exports IDepositUpdated
     * @interface IDepositUpdated
     * @property {string|null} [accountNo] DepositUpdated accountNo
     * @property {string|null} [depositAssets] DepositUpdated depositAssets
     */

    /**
     * Constructs a new DepositUpdated.
     * @exports DepositUpdated
     * @classdesc Represents a DepositUpdated.
     * @implements IDepositUpdated
     * @constructor
     * @param {IDepositUpdated=} [properties] Properties to set
     */
    function DepositUpdated(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DepositUpdated accountNo.
     * @member {string} accountNo
     * @memberof DepositUpdated
     * @instance
     */
    DepositUpdated.prototype.accountNo = "";

    /**
     * DepositUpdated depositAssets.
     * @member {string} depositAssets
     * @memberof DepositUpdated
     * @instance
     */
    DepositUpdated.prototype.depositAssets = "";

    /**
     * Creates a new DepositUpdated instance using the specified properties.
     * @function create
     * @memberof DepositUpdated
     * @static
     * @param {IDepositUpdated=} [properties] Properties to set
     * @returns {DepositUpdated} DepositUpdated instance
     */
    DepositUpdated.create = function create(properties) {
        return new DepositUpdated(properties);
    };

    /**
     * Encodes the specified DepositUpdated message. Does not implicitly {@link DepositUpdated.verify|verify} messages.
     * @function encode
     * @memberof DepositUpdated
     * @static
     * @param {IDepositUpdated} message DepositUpdated message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DepositUpdated.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.depositAssets != null && Object.hasOwnProperty.call(message, "depositAssets"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.depositAssets);
        return writer;
    };

    /**
     * Encodes the specified DepositUpdated message, length delimited. Does not implicitly {@link DepositUpdated.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DepositUpdated
     * @static
     * @param {IDepositUpdated} message DepositUpdated message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DepositUpdated.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DepositUpdated message from the specified reader or buffer.
     * @function decode
     * @memberof DepositUpdated
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DepositUpdated} DepositUpdated
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DepositUpdated.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DepositUpdated();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.depositAssets = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DepositUpdated message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DepositUpdated
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DepositUpdated} DepositUpdated
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DepositUpdated.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DepositUpdated message.
     * @function verify
     * @memberof DepositUpdated
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DepositUpdated.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            if (!$util.isString(message.depositAssets))
                return "depositAssets: string expected";
        return null;
    };

    /**
     * Creates a DepositUpdated message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DepositUpdated
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DepositUpdated} DepositUpdated
     */
    DepositUpdated.fromObject = function fromObject(object) {
        if (object instanceof $root.DepositUpdated)
            return object;
        let message = new $root.DepositUpdated();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.depositAssets != null)
            message.depositAssets = String(object.depositAssets);
        return message;
    };

    /**
     * Creates a plain object from a DepositUpdated message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DepositUpdated
     * @static
     * @param {DepositUpdated} message DepositUpdated
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DepositUpdated.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.depositAssets = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.depositAssets != null && message.hasOwnProperty("depositAssets"))
            object.depositAssets = message.depositAssets;
        return object;
    };

    /**
     * Converts this DepositUpdated to JSON.
     * @function toJSON
     * @memberof DepositUpdated
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DepositUpdated.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DepositUpdated
     * @function getTypeUrl
     * @memberof DepositUpdated
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DepositUpdated.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DepositUpdated";
    };

    return DepositUpdated;
})();

export const OrderClosed = $root.OrderClosed = (() => {

    /**
     * Properties of an OrderClosed.
     * @exports IOrderClosed
     * @interface IOrderClosed
     * @property {string|null} [accountNo] OrderClosed accountNo
     * @property {string|null} [purchaseDateTime] OrderClosed purchaseDateTime
     * @property {string|null} [orderNo] OrderClosed orderNo
     * @property {string|null} [executionDateTime] OrderClosed executionDateTime
     * @property {string|null} [stockCd] OrderClosed stockCd
     * @property {string|null} [tradeCurrencyCd] OrderClosed tradeCurrencyCd
     * @property {string|null} [positionCd] OrderClosed positionCd
     * @property {string|null} [closeOutQuantity] OrderClosed closeOutQuantity
     * @property {string|null} [purchasePrice] OrderClosed purchasePrice
     * @property {string|null} [closeOutPrice] OrderClosed closeOutPrice
     * @property {string|null} [closeOutProfitLoss] OrderClosed closeOutProfitLoss
     * @property {string|null} [executionCharge] OrderClosed executionCharge
     * @property {string|null} [swapCharge] OrderClosed swapCharge
     */

    /**
     * Constructs a new OrderClosed.
     * @exports OrderClosed
     * @classdesc Represents an OrderClosed.
     * @implements IOrderClosed
     * @constructor
     * @param {IOrderClosed=} [properties] Properties to set
     */
    function OrderClosed(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderClosed accountNo.
     * @member {string} accountNo
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.accountNo = "";

    /**
     * OrderClosed purchaseDateTime.
     * @member {string} purchaseDateTime
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.purchaseDateTime = "";

    /**
     * OrderClosed orderNo.
     * @member {string} orderNo
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.orderNo = "";

    /**
     * OrderClosed executionDateTime.
     * @member {string} executionDateTime
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.executionDateTime = "";

    /**
     * OrderClosed stockCd.
     * @member {string} stockCd
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.stockCd = "";

    /**
     * OrderClosed tradeCurrencyCd.
     * @member {string} tradeCurrencyCd
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.tradeCurrencyCd = "";

    /**
     * OrderClosed positionCd.
     * @member {string} positionCd
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.positionCd = "";

    /**
     * OrderClosed closeOutQuantity.
     * @member {string} closeOutQuantity
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.closeOutQuantity = "";

    /**
     * OrderClosed purchasePrice.
     * @member {string} purchasePrice
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.purchasePrice = "";

    /**
     * OrderClosed closeOutPrice.
     * @member {string} closeOutPrice
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.closeOutPrice = "";

    /**
     * OrderClosed closeOutProfitLoss.
     * @member {string} closeOutProfitLoss
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.closeOutProfitLoss = "";

    /**
     * OrderClosed executionCharge.
     * @member {string} executionCharge
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.executionCharge = "";

    /**
     * OrderClosed swapCharge.
     * @member {string} swapCharge
     * @memberof OrderClosed
     * @instance
     */
    OrderClosed.prototype.swapCharge = "";

    /**
     * Creates a new OrderClosed instance using the specified properties.
     * @function create
     * @memberof OrderClosed
     * @static
     * @param {IOrderClosed=} [properties] Properties to set
     * @returns {OrderClosed} OrderClosed instance
     */
    OrderClosed.create = function create(properties) {
        return new OrderClosed(properties);
    };

    /**
     * Encodes the specified OrderClosed message. Does not implicitly {@link OrderClosed.verify|verify} messages.
     * @function encode
     * @memberof OrderClosed
     * @static
     * @param {IOrderClosed} message OrderClosed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderClosed.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.accountNo != null && Object.hasOwnProperty.call(message, "accountNo"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountNo);
        if (message.purchaseDateTime != null && Object.hasOwnProperty.call(message, "purchaseDateTime"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.purchaseDateTime);
        if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.orderNo);
        if (message.executionDateTime != null && Object.hasOwnProperty.call(message, "executionDateTime"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.executionDateTime);
        if (message.stockCd != null && Object.hasOwnProperty.call(message, "stockCd"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.stockCd);
        if (message.tradeCurrencyCd != null && Object.hasOwnProperty.call(message, "tradeCurrencyCd"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.tradeCurrencyCd);
        if (message.positionCd != null && Object.hasOwnProperty.call(message, "positionCd"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.positionCd);
        if (message.closeOutQuantity != null && Object.hasOwnProperty.call(message, "closeOutQuantity"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.closeOutQuantity);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.purchasePrice);
        if (message.closeOutPrice != null && Object.hasOwnProperty.call(message, "closeOutPrice"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.closeOutPrice);
        if (message.closeOutProfitLoss != null && Object.hasOwnProperty.call(message, "closeOutProfitLoss"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.closeOutProfitLoss);
        if (message.executionCharge != null && Object.hasOwnProperty.call(message, "executionCharge"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.executionCharge);
        if (message.swapCharge != null && Object.hasOwnProperty.call(message, "swapCharge"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.swapCharge);
        return writer;
    };

    /**
     * Encodes the specified OrderClosed message, length delimited. Does not implicitly {@link OrderClosed.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderClosed
     * @static
     * @param {IOrderClosed} message OrderClosed message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderClosed.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderClosed message from the specified reader or buffer.
     * @function decode
     * @memberof OrderClosed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderClosed} OrderClosed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderClosed.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderClosed();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.accountNo = reader.string();
                    break;
                }
            case 2: {
                    message.purchaseDateTime = reader.string();
                    break;
                }
            case 3: {
                    message.orderNo = reader.string();
                    break;
                }
            case 4: {
                    message.executionDateTime = reader.string();
                    break;
                }
            case 5: {
                    message.stockCd = reader.string();
                    break;
                }
            case 6: {
                    message.tradeCurrencyCd = reader.string();
                    break;
                }
            case 7: {
                    message.positionCd = reader.string();
                    break;
                }
            case 8: {
                    message.closeOutQuantity = reader.string();
                    break;
                }
            case 9: {
                    message.purchasePrice = reader.string();
                    break;
                }
            case 10: {
                    message.closeOutPrice = reader.string();
                    break;
                }
            case 11: {
                    message.closeOutProfitLoss = reader.string();
                    break;
                }
            case 12: {
                    message.executionCharge = reader.string();
                    break;
                }
            case 13: {
                    message.swapCharge = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderClosed message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderClosed
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderClosed} OrderClosed
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderClosed.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderClosed message.
     * @function verify
     * @memberof OrderClosed
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderClosed.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            if (!$util.isString(message.accountNo))
                return "accountNo: string expected";
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            if (!$util.isString(message.purchaseDateTime))
                return "purchaseDateTime: string expected";
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            if (!$util.isString(message.orderNo))
                return "orderNo: string expected";
        if (message.executionDateTime != null && message.hasOwnProperty("executionDateTime"))
            if (!$util.isString(message.executionDateTime))
                return "executionDateTime: string expected";
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            if (!$util.isString(message.stockCd))
                return "stockCd: string expected";
        if (message.tradeCurrencyCd != null && message.hasOwnProperty("tradeCurrencyCd"))
            if (!$util.isString(message.tradeCurrencyCd))
                return "tradeCurrencyCd: string expected";
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            if (!$util.isString(message.positionCd))
                return "positionCd: string expected";
        if (message.closeOutQuantity != null && message.hasOwnProperty("closeOutQuantity"))
            if (!$util.isString(message.closeOutQuantity))
                return "closeOutQuantity: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            if (!$util.isString(message.purchasePrice))
                return "purchasePrice: string expected";
        if (message.closeOutPrice != null && message.hasOwnProperty("closeOutPrice"))
            if (!$util.isString(message.closeOutPrice))
                return "closeOutPrice: string expected";
        if (message.closeOutProfitLoss != null && message.hasOwnProperty("closeOutProfitLoss"))
            if (!$util.isString(message.closeOutProfitLoss))
                return "closeOutProfitLoss: string expected";
        if (message.executionCharge != null && message.hasOwnProperty("executionCharge"))
            if (!$util.isString(message.executionCharge))
                return "executionCharge: string expected";
        if (message.swapCharge != null && message.hasOwnProperty("swapCharge"))
            if (!$util.isString(message.swapCharge))
                return "swapCharge: string expected";
        return null;
    };

    /**
     * Creates an OrderClosed message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderClosed
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderClosed} OrderClosed
     */
    OrderClosed.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderClosed)
            return object;
        let message = new $root.OrderClosed();
        if (object.accountNo != null)
            message.accountNo = String(object.accountNo);
        if (object.purchaseDateTime != null)
            message.purchaseDateTime = String(object.purchaseDateTime);
        if (object.orderNo != null)
            message.orderNo = String(object.orderNo);
        if (object.executionDateTime != null)
            message.executionDateTime = String(object.executionDateTime);
        if (object.stockCd != null)
            message.stockCd = String(object.stockCd);
        if (object.tradeCurrencyCd != null)
            message.tradeCurrencyCd = String(object.tradeCurrencyCd);
        if (object.positionCd != null)
            message.positionCd = String(object.positionCd);
        if (object.closeOutQuantity != null)
            message.closeOutQuantity = String(object.closeOutQuantity);
        if (object.purchasePrice != null)
            message.purchasePrice = String(object.purchasePrice);
        if (object.closeOutPrice != null)
            message.closeOutPrice = String(object.closeOutPrice);
        if (object.closeOutProfitLoss != null)
            message.closeOutProfitLoss = String(object.closeOutProfitLoss);
        if (object.executionCharge != null)
            message.executionCharge = String(object.executionCharge);
        if (object.swapCharge != null)
            message.swapCharge = String(object.swapCharge);
        return message;
    };

    /**
     * Creates a plain object from an OrderClosed message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderClosed
     * @static
     * @param {OrderClosed} message OrderClosed
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderClosed.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.accountNo = "";
            object.purchaseDateTime = "";
            object.orderNo = "";
            object.executionDateTime = "";
            object.stockCd = "";
            object.tradeCurrencyCd = "";
            object.positionCd = "";
            object.closeOutQuantity = "";
            object.purchasePrice = "";
            object.closeOutPrice = "";
            object.closeOutProfitLoss = "";
            object.executionCharge = "";
            object.swapCharge = "";
        }
        if (message.accountNo != null && message.hasOwnProperty("accountNo"))
            object.accountNo = message.accountNo;
        if (message.purchaseDateTime != null && message.hasOwnProperty("purchaseDateTime"))
            object.purchaseDateTime = message.purchaseDateTime;
        if (message.orderNo != null && message.hasOwnProperty("orderNo"))
            object.orderNo = message.orderNo;
        if (message.executionDateTime != null && message.hasOwnProperty("executionDateTime"))
            object.executionDateTime = message.executionDateTime;
        if (message.stockCd != null && message.hasOwnProperty("stockCd"))
            object.stockCd = message.stockCd;
        if (message.tradeCurrencyCd != null && message.hasOwnProperty("tradeCurrencyCd"))
            object.tradeCurrencyCd = message.tradeCurrencyCd;
        if (message.positionCd != null && message.hasOwnProperty("positionCd"))
            object.positionCd = message.positionCd;
        if (message.closeOutQuantity != null && message.hasOwnProperty("closeOutQuantity"))
            object.closeOutQuantity = message.closeOutQuantity;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = message.purchasePrice;
        if (message.closeOutPrice != null && message.hasOwnProperty("closeOutPrice"))
            object.closeOutPrice = message.closeOutPrice;
        if (message.closeOutProfitLoss != null && message.hasOwnProperty("closeOutProfitLoss"))
            object.closeOutProfitLoss = message.closeOutProfitLoss;
        if (message.executionCharge != null && message.hasOwnProperty("executionCharge"))
            object.executionCharge = message.executionCharge;
        if (message.swapCharge != null && message.hasOwnProperty("swapCharge"))
            object.swapCharge = message.swapCharge;
        return object;
    };

    /**
     * Converts this OrderClosed to JSON.
     * @function toJSON
     * @memberof OrderClosed
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderClosed.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for OrderClosed
     * @function getTypeUrl
     * @memberof OrderClosed
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    OrderClosed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OrderClosed";
    };

    return OrderClosed;
})();

export { $root as default };